import React, { useRef, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Slider from "react-slick";
import moment from "moment";

import { Link, useHistory } from "react-router-dom";
import Loader from "../../components/Loading/loading";
import LinkButton from "../../utils/LinkButton";
import Carousel from "../../components/Slick/CarouselCandidatoConecta";
import ico_group from "../../static/images/ico-group.svg";
import useOnceEffect from "../../Hooks/useOnceEffect";
import AddCircle from "../../assets/svg/addCircle";
import { Modal } from "react-bootstrap";
import useToggle from "../../Hooks/useToggle";
import useSlickSettings from "../../utils/Slick/SlickSettings";
import CardInputFile from "../../utils/CardInputFile.js/CardInputFile";
import AddEventButton from "../../components/Events/AddEventButton";
import ico_add_img from "../../static/images/ico-add_img.svg";

import "../../static/css/custom.css";
import "../../static/css/conectStyle.css";
import useDebounce from "../../Hooks/useDebounce";
import { NextArrow, PrevArrow } from "../Applicant/Conecta";
import useBaseURL from "../../Hooks/useBaseURL";

import defaultLogo from "../../static/images/472.png";
import zIndex from "@material-ui/core/styles/zIndex";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  centerMode: false,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 912,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,

        infinite: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
      },
    },
  ],
};

const Conecta = ({ data }) => {
  const [loading, setLoading] = useState(true);
  const [listRegisterUser, setlistRegisterUser] = useState([]);
  const [contactosList, setcontactosList] = useState([]);
  const [index] = useState(0);

  const [empresasList, setempresasList] = useState({ filter: [], data: [] });
  const [centrosList, setcentrosList] = useState({ filter: [], data: [] });
  const [listEvents, setlistVents] = useState({ filter: [], data: [] });
  const history = useHistory();
  const [path, setPath] = useState("");
  const [ROLE, setRole] = useState("");
  const USER_BASE_URL = useRef("");

  const debounceSearch = useDebounce(
    (search = "", key = "", setEstado = () => {}) => {
      setEstado((_old) => {
        if (search === "") {
          return {
            ..._old,
            filter: _old.data,
          };
        }

        let _new = _old.data.filter((elm) => {
          return elm[key].toLowerCase().includes(search.toLowerCase());
        });

        return {
          ..._old,
          filter: _new,
        };
      });
    }
  );

  function GetEvents() {
    axios.get("/exclusive-events-currently").then((result) => {
      setlistVents({
        filter: result.data,
        data: result.data,
      });
    });
  }

  function GetUserList(index, qty) {
    axios
      .get("access/list-applicants", {
        params: {
          page: index,
          paginate: qty,
        },
      })
      .then((result) => {
        let arr = result.data.content;
        setlistRegisterUser([...arr, listRegisterUser]);
        // setcontactosList(result.data.content.slice(0, result.data.lenght));
        setLoading(false);
      });
  }
  function GetContactoList(index, qty) {
    axios
      .get("access/list-applicants", {
        params: {
          page: index,
          paginate: qty,
        },
      })
      .then((result) => {
        let arr = result.data.content;
        // setlistRegisterUser([...arr, listRegisterUser]);
        setcontactosList([...arr, contactosList]);
        setLoading(false);
      });
  }

  function setLinkCentroFormacion(item) {
    let rol = localStorage.getItem("rol");

    switch (rol) {
      case "applicant":
        setPath("/user/");
        history.push({
          pathname: "/user/PerfilEmpresa",
          state: { profileId: item },
        });
        break;
      case "company":
        setPath("/company/");
        history.push({
          pathname: "/company/Empresa",
          state: { profileId: item },
        });
        break;
      case "institute":
        setPath("/CentroFormacion/");
        history.push({
          pathname: "/CentroFormacion/Empresa",
          state: { profileId: item },
        });
        break;

      default:
        break;
    }
  }

  function setLinkAliados(item) {
    let rol = localStorage.getItem("rol");

    switch (rol) {
      case "applicant":
        history.push({
          pathname: "/user/PerfilEmpresa",
          state: { profileId: item },
        });
        break;
      case "company":
        history.push({
          pathname: "/company/Empresa",
          state: { profileId: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/Empresa",
          state: { profileId: item },
        });
        break;

      default:
        break;
    }
  }

  useOnceEffect(() => {
    const getEmpresas = () => {
      axios.get("access/list-company").then((result) => {
        if (result.status === 200) {
          setempresasList({
            filter: result.data,
            data: result.data,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };

    const getCentros = () => {
      axios.get("formacion/list").then((result) => {
        if (result.status === 200) {
          setcentrosList({
            filter: result.data,
            data: result.data,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };

    GetUserList(index, 3);
    GetContactoList();
    getEmpresas();
    getCentros();

    //GetEvents();
  });

  useOnceEffect(() => {
    if (data != null) {
      GetEvents();
      baseUrl();
    }
  });

  function baseUrl() {
    const role = localStorage.getItem("rol");
    setRole(role);
    switch (role) {
      case "applicant":
        USER_BASE_URL.current = "user";
        break;
      case "company":
        USER_BASE_URL.current = "company";
        break;
      case "institute":
        USER_BASE_URL.current = "CentroFormacion";
        break;

      default:
        break;
    }
  }

  return (
    <div className="vacantes perfil-empresa usuario">
      {loading ? <Loader type="full"></Loader> : ""}

      <div id="conect">
        <div className="container mt-3">
          <div className="row vacancy__content">
            <div className="col-12 col-md-4 col-lg-4" style={{ zIndex: 0 }}>
              <MiRed path={USER_BASE_URL.current} />
            </div>
            <div className="col-12 col-md-8 col-lg-8">
              <div className="vacancy__description bordered-box">
                <Carousel id="Vacante" qty="3" titulo="Comunidad Krezco" />

                <div className="mb-5 mt-5 ps-2 pe-2">
                  <hr></hr>
                </div>

                <Carousel id="Vacantes" qty="3" titulo="Sugerencias para tí" />
              </div>

              <div className="vacancy__description bordered-box">
                <GruposSlide />
              </div>

              <div className="vacancy__description bordered-box">
                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6">
                    <div className="p-2 bordered-box__header-title">
                      <span className="align-middle ">Nuestros Aliados</span>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 text-end">
                    <div className="search">
                      <i className="fas fa-search"></i>
                      <input
                        type="text"
                        placeholder="Buscar"
                        onChange={({ target }) =>
                          debounceSearch(target.value, "name", setempresasList)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="autoplay">
                  <Slider {...settings}>
                    {empresasList.filter.map((item, index) => (
                      <div key={item.companyId} className="conect-card">
                        <div className="card">
                          <div className="mt-4 box-imgCat2">
                            <img
                              src={
                                item.profileImagePath !== null
                                  ? item.profileImagePath
                                  : defaultLogo
                              }
                              alt=""
                              onClick={() => setLinkAliados(item.companyId)}
                            ></img>
                          </div>
                          <div className="card-body">
                            <h5 className="mb-3 card-title">{item.name}</h5>
                            <div className="mt-4 mb-4 badges2"></div>
                            <hr></hr>

                            {/* <a href="#" className="mt-4 mb-2 btn btn-info">
                              Ver
                            </a> */}
                            <button
                              className="mt-4 mb-2 btn btn-info"
                              onClick={() => setLinkAliados(item.companyId)}
                            >
                              Ver Perfil
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>

              <div className="vacancy__description bordered-box">
                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6">
                    <div className="p-2 bordered-box__header-title">
                      <span className="align-middle ">Centro de Formacion</span>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 text-end">
                    <div className="search">
                      <i className="fas fa-search"></i>
                      <input
                        type="text"
                        placeholder="Buscar"
                        onChange={({ target }) =>
                          debounceSearch(target.value, "name", setcentrosList)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="autoplay">
                  <Slider {...settings}>
                    {centrosList.filter.map((item, index) => (
                      <div key={item.companyId} className="conect-card">
                        <div className="card">
                          <div className="mt-4 box-imgCat2">
                            <img
                              src={
                                item.profileImagePath !== null
                                  ? item.profileImagePath
                                  : defaultLogo
                              }
                              alt=""
                              onClick={() =>
                                setLinkCentroFormacion(item.companyId)
                              }
                            ></img>
                          </div>
                          <div className="card-body">
                            <h5 className="mb-3 card-title">{item.name}</h5>
                            <div className="mt-4 mb-4 badges2"></div>
                            <hr></hr>

                            {/* <a href="#" className="mt-4 mb-2 btn btn-info">
                              Ver
                            </a> */}
                            <button
                              className="mt-4 mb-2 btn btn-info"
                              onClick={() =>
                                setLinkCentroFormacion(item.companyId)
                              }
                            >
                              Ver Perfil
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>

                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6"></div>
                  <div className="col-12 col-md-6 text-end"></div>
                </div>
              </div>

              <div className="events vacancy__description bordered-box">
                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6">
                    <div className="p-2 bordered-box__header-title">
                      <span className="align-middle ">Próximos Eventos</span>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 text-end">
                    <div className="search">
                      <i className="fas fa-search"></i>
                      <input
                        type="text"
                        placeholder="Buscar"
                        onChange={({ target }) =>
                          debounceSearch(target.value, "name", setlistVents)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="autoplay">
                  <Slider {...settings}>
                    {listEvents.filter.map((item) => {
                      return (
                        <div className="conect-card">
                          <div className="card">
                            <div className="box-imgCat3 default-cover-evento">
                              <img src={item.image} alt=""></img>
                            </div>
                            <div className="card-body">
                              <h5 className="mb-3 card-title">{item.name}</h5>
                              <div className="mt-4 mb-4 badges3">
                                <h6>
                                  Fecha:{" "}
                                  <span>
                                    {moment(item.startDate).calendar()}
                                  </span>
                                </h6>
                                <h6>
                                  Lugar: <span>{item.place}</span>
                                </h6>
                              </div>
                              <hr></hr>

                              <LinkButton
                                to={{
                                  pathname: "/company/DetalleEvento",
                                  state: item,
                                }}
                                type="button"
                                className="btn btn-info"
                              >
                                Ver
                              </LinkButton>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>

                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function MiRed({ path }) {
  const [group, toggleGroup] = useToggle(false);
  return (
    <>
      <aside className="vacancy__sidebar sticky-top ">
        <main className="bordered-box ">
          <section className="bordered-box__header mb-4">
            <div className="bordered-box__header-title">Mi Red</div>
          </section>

          <section className="d-flex justify-content-between">
            <div className="col-1 col-md-1">
              <img
                src={ico_group}
                alt="Grupos"
                onClick={() =>
                  document.getElementById("group_carousel")?.scrollIntoView()
                }
              />
            </div>
            <div className="col-10  pb-1 pe-1 ps-1 text-left">
              <span className="card-text" type="button">
                Grupos
              </span>
            </div>
            <div className="pb-1 pe-1 ps-1">
              <AddCircle onClick={toggleGroup} />
            </div>
          </section>
          <hr style={{ marginBottom: "13px" }} />
          <section className="d-flex justify-content-between">
            <div>
              <i
                className="fas fa-calendar-check"
                style={{ marginRight: "13px" }}
              />
              <Link to={`/${path}/Eventos`}>
                <span className="card-text">Eventos</span>
              </Link>
            </div>
            {/* <AddCircle /> */}
            <AddEventButton></AddEventButton>
          </section>
        </main>
      </aside>

      <AddGroupModal show={group} onHide={toggleGroup} />
    </>
  );
}

export function GruposSlide({ url = "company" }) {
  const [state, setState] = useState({
    filter: [],
    data: [],
  });

  const history = useHistory();
  const slickSettings = useSlickSettings({ ...settings, infinite: false });

  const debounceSearch = useDebounce(
    (search = "") => {
      setState((_old) => {
        if (search === "") {
          return {
            ..._old,
            filter: _old.data,
          };
        }

        let _new = _old.data.filter((elm) =>
          elm.name.toLowerCase().includes(search.toLowerCase())
        );

        return {
          ..._old,
          filter: _new,
        };
      });
    },
    [setState]
  );

  function SlideCard(name, id, image) {
    return (
      <div className="conect-card" id="group_carousel">
        <div className="card">
          <div className="mt-4 box-imgCat2 default-cover">
            <img src={image} className="img_cover" alt={"slide-" + name}></img>
          </div>
          <div className="card-body">
            <h5 className="mb-3 card-title">{name}</h5>
            <div className="mt-4 mb-4 badges2"></div>
            <hr></hr>

            <span
              className="mt-4 mb-2 btn btn-info"
              onClick={() => history.push(`/${url}/group-connect/${id}`)}
            >
              Ver
            </span>
          </div>
        </div>
      </div>
    );
  }

  useOnceEffect(() => {
    let is_mounted = true;
    axios.get("groups").then((res) => {
      if (is_mounted)
        setState({
          filter: res.data,
          data: res.data,
        });
    });

    return () => {
      is_mounted = false;
    };
  });

  return (
    <>
      <div className="row mt-2 mb-4">
        <div className="col-12 col-md-6">
          <div className="p-2 bordered-box__header-title">
            <span className="align-middle ">Tus Grupos</span>
          </div>
        </div>

        <div className="col-12 col-md-6 text-end">
          <div className="search">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Buscar"
              onChange={({ target }) => debounceSearch(target.value)}
            />
          </div>
        </div>
      </div>

      <div className="autoplay">
        <Slider {...slickSettings}>
          {state.filter.map((elm) => SlideCard(elm.name, elm.id, elm.image))}
        </Slider>
      </div>
    </>
  );
}

function AddGroupModal({ show, onHide }) {
  const [group, setGroup] = useState({
    name: "",
    description: "",
    rules: "",
  });

  //saves de target
  const [file, setFile] = useState(null);
  const [profile, setProfile] = useState(null);

  const [hasBeenClicked, setHasBeenClicked] = useState(false);
  const baseUrl = useBaseURL();
  const history = useHistory();

  function addGroup(e) {
    if (hasBeenClicked) return;
    else {
      setHasBeenClicked(true);
      e.preventDefault();
      let data = new FormData();

      data.append("name", group.name);
      data.append("description", group.description);
      data.append("rules", group.rules);
      data.append("image", file.files[0]);
      data.append("coverImage", profile.files[0]);

      axios.post("groups", data).then((res) => {
        toast.success(res.data.message, { duration: 3000 });
        setHasBeenClicked(false);
        onHide();
        history.push(`/${baseUrl}/group-connect/${res.data.data.id}`);
      });
    }
  }

  return (
    <Modal show={show} onHide={onHide} dialogClassName="kr-modal">
      <Modal.Header>
        <Modal.Title>Crear Grupo</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={addGroup}>
          <CardInputFile
            onChange={setProfile}
            label="Click para subir imagen de fondo"
            styles={{ zIndex: 1 }}
            color="rgba(0,0,0,0)"
          />

          <CardInputFile
            onChange={setFile}
            width="5rem"
            height="5rem"
            color="rgba(0,0,0,0)"
            label=""
            styles={{
              width: "5rem",
              height: "5rem",
              transform: "translate(50%,-50%)",
              zIndex: 2,
            }}
            bg={ico_add_img}
          />

          <div className="form-group p-3">
            <label>Nombre del grupo</label>
            <input
              className="form-control"
              value={group.name}
              onChange={({ target }) =>
                setGroup({ ...group, name: target.value })
              }
            />
          </div>

          <div className="form-group p-3">
            <label>Acerca del grupo</label>
            <textarea
              className="form-control"
              rows={3}
              value={group.description}
              onChange={({ target }) =>
                setGroup({ ...group, description: target.value })
              }
            />
          </div>

          <div className="form-group p-3">
            <label>Reglas / Información adicional</label>
            <textarea
              className="form-control"
              rows={3}
              value={group.rules}
              onChange={({ target }) =>
                setGroup({ ...group, rules: target.value })
              }
            />
          </div>

          <button className="btn-deg">Crear group</button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default Conecta;
